import i18n from "../../shared/i18n/i18n";
import SharedConstants from "../shared_constants";

export function getLocale() {
	return i18n.locale || i18n.getCurrentLocale();
}

export function isLocaleSupported(locale) {
	return locale && Intl.DateTimeFormat.supportedLocalesOf([locale]).length > 0;
}

export function formatDateManually(date) {
	const d = new Date(date);
	const dayName = i18n.t(`weekday_${d.getDay()}`);
	const monthName = i18n.t(`month_short_${d.getMonth()}`);
	const day = d.getDate();
	const year = d.getFullYear();
	const hours = d.getHours().toString().padStart(2, "0");
	const minutes = d.getMinutes().toString().padStart(2, "0");
	return `${dayName}, ${day} ${monthName} ${year}, ${hours}:${minutes}`;
}

const DateUtilities = {
	getFormattedDate: function (date) {
		if (!date)
			return "";

		const locale = getLocale();
		if (!isLocaleSupported(locale))
			return formatDateManually(date);
		return new Date(date).toLocaleTimeString(locale, { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
	},
	getFormattedDateFromUTC: function (date) {
		if (!date)
			return "";

		if(!date.endsWith("Z"))
			date += "Z"
		const locale = getLocale();
		if (!isLocaleSupported(locale))
			return formatDateManually(date);
		return new Date(date).toLocaleTimeString(locale, { weekday: "long", year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
	},
	parseUTC: function (date) {
		if (!date)
			return "";

		// The date is assumed to be the Clock time in UTC
		// Date will add the Browsers timezone. We need to strip 
		// the timezone without affecting the clock time. 
		let dateParsed = new Date(date)
		let userTimezoneOffset = dateParsed.getTimezoneOffset() * 60000;
		let isoString = new Date(dateParsed.getTime() - userTimezoneOffset).toISOString()
		return isoString.substring(0, isoString.indexOf("."))
	},

	getFormattedMonthLong: function (date) {
		const locale = getLocale();
		if (!isLocaleSupported(locale))
			return i18n.t(`month_short_${new Date(date).getMonth()}`);
		return new Date(date).toLocaleDateString(locale, { month: "long" });
	},

	getLocaleDateString: function (language) {
        return SharedConstants.dateFormats[language] || "DD/MM/YYYY";
    },

    toISOWithoutTimezone: function (dateTime) {
        if (!(dateTime instanceof Date)) {
            dateTime = new Date(dateTime);
        }
        const timeZoneOffsetMinutes = dateTime.getTimezoneOffset();

        const dateTimeWithoutTimeZoneOffset = new Date(dateTime.getTime() - timeZoneOffsetMinutes * 60000);

        return dateTimeWithoutTimeZoneOffset.toISOString();
    }
}

export default DateUtilities;
